// Submenu.jsx — R3: resa grafica UNICA del secondo livello (design §6.1).
// Un solo renderer per le voci di nav[] del contratto v2: sezioni, voci con
// label dal glossario (glossKey mancante = throw, B2.17), badge dal bus (via
// host), filtro adminOnly su getUser().role, stato attivo unico.
// La STESSA lista serve la colonna desktop (#shell-submenu) e lo sheet sezioni
// mobile della MobileBar (variant "sheet"): mai due rese divergenti.
//
// Ondata 6:
//  - HEADER DI CONTESTO in testa (desktop e mobile): titolo = nome modulo dal
//    glossario (fallback label di registrazione), sottotitolo = descrizione breve
//    (glossario <id>.subtitle; assente ⇒ solo titolo). Il sottomenù dichiara
//    SEMPRE di quale modulo è.
//  - SEZIONI SEMPRE DIVISE: ogni sezione vive in un blocco .sm-sec (divisore CSS
//    tra blocchi adiacenti) con intestazione marcata (uppercase, accent); anche
//    una sezione sola tiene la sua intestazione. section null (contratto v2) =
//    blocco senza titolo, ma comunque separato dal divisore.
//  - il footer tiene SOLO le azioni contestuali del modulo (per proc: Preventivo
//    veloce / Registra azione). Utente, lingua e logout sono MIGRATI nel fondo
//    del menu principale (Rail desktop / modsheet mobile) — vedi UserZone.jsx.

import React from 'react';
import { label } from './glossary.js';

function isAdmin(user) {
  return !!(user && user.role === 'admin');
}

// Lista voci — variant 'column' (desktop) o 'sheet' (mobile). onSelect(itemId).
export function SubmenuList({ nav, activeItem, user, host, moduleId, onSelect }) {
  const admin = isAdmin(user);
  return (
    <React.Fragment>
      {nav.map((sec, i) => {
        const items = (sec.items || []).filter((it) => !it.adminOnly || admin);
        if (items.length === 0) return null;
        return (
          <div className="sm-sec" key={sec.section || 's' + i}>
            {sec.section && <div className="sm-section">{label(sec.section)}</div>}
            {items.map((it) => {
              const badge = it.badge ? host.itemBadge(moduleId, it.id) : 0;
              const isActive = activeItem === it.id;
              return (
                <button
                  key={it.id}
                  type="button"
                  className={'sm-item' + (isActive ? ' active' : '')}
                  aria-current={isActive ? 'page' : undefined}
                  onClick={() => onSelect(it.id)}
                >
                  <span>{label(it.glossKey)}</span>
                  {badge > 0 && <span className="sm-badge">{badge > 99 ? '99+' : badge}</span>}
                </button>
              );
            })}
          </div>
        );
      })}
    </React.Fragment>
  );
}

// Header di contesto del sottomenù (ondata 6): titolo + sottotitolo del modulo.
// Riusato IDENTICO da colonna desktop e sheet sezioni mobile (resa unica §6.1).
export function SubmenuHeader({ title, subtitle }) {
  return (
    <div className="sm-head">
      <div className="sm-title">{title}</div>
      {!!subtitle && <div className="sm-sub">{subtitle}</div>}
    </div>
  );
}

// Footer desktop: SOLO azioni contestuali del modulo — per proc i proxy dei
// bottoni rapidi del #sidebar nascosto (#sb-quick-quote / #sb-quick-log), resi
// SOLO se il bersaglio esiste nel DOM (bersaglio sparito = bottone assente alla
// prossima resa, mai un click nel vuoto). Altri moduli: nessun footer.
function SubmenuFooter({ moduleId }) {
  const doc = document;
  if (moduleId !== 'proc') return null; // azioni contestuali censite: oggi solo proc ne ha
  const hasQuote = !!doc.getElementById('sb-quick-quote');
  const hasLog = !!doc.getElementById('sb-quick-log');
  if (!hasQuote && !hasLog) return null;
  return (
    <div className="sm-foot">
      {hasQuote && (
        <button type="button" className="sm-action" onClick={() => doc.getElementById('sb-quick-quote').click()}>
          {label('proc.quick_quote')}
        </button>
      )}
      {hasLog && (
        <button type="button" className="sm-action ghost" onClick={() => doc.getElementById('sb-quick-log').click()}>
          {label('proc.quick_log')}
        </button>
      )}
    </div>
  );
}

// Colonna desktop del sottomenù shell. Visibile solo con body.shell-submenu
// (il host la sincronizza da submenuData): qui si rende sempre che ci siano dati.
export function Submenu({ host, data }) {
  const { id, nav, activeItem, title, subtitle } = data;
  return (
    <aside id="shell-submenu" aria-label={label('shell.submenu.aria')}>
      <SubmenuHeader title={title} subtitle={subtitle} />
      <div className="sm-scroll">
        <SubmenuList
          nav={nav}
          activeItem={activeItem}
          user={host.user()}
          host={host}
          moduleId={id}
          onSelect={(itemId) => host.navigate(id, itemId)}
        />
      </div>
      <SubmenuFooter moduleId={id} />
    </aside>
  );
}
